import { render, staticRenderFns } from "./BaseColumnOrdinalNumber.vue?vue&type=template&id=41c1077b&scoped=true&"
import script from "./BaseColumnOrdinalNumber.vue?vue&type=script&lang=js&"
export * from "./BaseColumnOrdinalNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c1077b",
  null
  
)

export default component.exports